import type { PageGroup } from '../pageGroup';
import type { PageModel } from '../pageModel';
import { flattenPageGroups } from './flattenPageGroups';
import { getPage } from './getPage';
import type { PageGroupItemViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';

export function pageViewModel(pageId: number, pageGroups: PageGroup[]): PageModel {
  const pages: PageGroupItemViewModel[] = flattenPageGroups(pageGroups);
  const page = getPage(pageId, pages);
  if (page) {
    return {
      pageId,
      name: translateTemplateName(page.name),
      helpContent: page.helpContent,
    };
  }
  throw new Error('IllegalState (E902), pageId ' + pageId);
}
